export const PageTitle = ({ title, subtitle, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-7">
    <div>
      <h1 className="font-serif text-3xl sm:text-4xl font-semibold text-ink">{title}</h1>
      {subtitle && <p className="text-ink-soft text-sm mt-1">{subtitle}</p>}
    </div>
    {children && <div className="flex gap-2">{children}</div>}
  </div>
);

const STATUS_COLORS = {
  New: "bg-blue-100 text-blue-700",
  Reviewed: "bg-indigo-100 text-indigo-700",
  Contacted: "bg-amber-100 text-amber-700",
  "Waiting for Client": "bg-orange-100 text-orange-700",
  "Availability Sent": "bg-cyan-100 text-cyan-700",
  "Deposit Pending": "bg-purple-100 text-purple-700",
  Confirmed: "bg-green-100 text-green-700",
  Closed: "bg-gray-200 text-gray-600",
  "Not a Fit": "bg-red-100 text-red-600",
  Published: "bg-green-100 text-green-700",
  Draft: "bg-gray-200 text-gray-600",
  Paused: "bg-amber-100 text-amber-700",
  Expired: "bg-red-100 text-red-600",
  "Coming Soon": "bg-sky-100 text-sky-700",
  "Open for Booking": "bg-green-100 text-green-700",
  Waitlist: "bg-amber-100 text-amber-700",
  "Sold Out": "bg-rose-100 text-rose-700",
  Completed: "bg-slate-200 text-slate-600",
  Archived: "bg-gray-200 text-gray-500",
};

export const StatusBadge = ({ status }) => (
  <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${STATUS_COLORS[status] || "bg-bone text-ink-soft"}`}>
    {status}
  </span>
);

export const StatCard = ({ icon: Icon, label, value, testid }) => (
  <div data-testid={testid} className="bg-white rounded-2xl border border-bone p-5 shadow-sm">
    <div className="flex items-center justify-between">
      <p className="text-ink-soft text-sm font-medium">{label}</p>
      {Icon && <Icon size={18} className="text-terracotta" strokeWidth={1.75} />}
    </div>
    <p className="font-serif text-4xl font-semibold text-ink mt-3">{value}</p>
  </div>
);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return iso;
  }
};
